import axios from "axios";
import {
  rest
} from "lodash";
// 上报数据到大数据平台
// 生成app_key  http://hd.noahedu.com/hadRecord/record/getAppKey?app_package=com.anoah.market-h5-clue&app_name=market-h5-clue

const MACHINE_NO = "2022101417050000000"; // 产品序列号，如果没有定义为常量，用于在数据后台中筛选数据
const TITLE_MAPS = {
  '#/': '报名表单页',
  '#/clue-input': '报名表单页',
  '#/clue-input/': '报名表单页',
  '#/result': '报名成功页',
  '#/result/': '报名成功页',
  '#/recruit-activity': '招募链接',
  '#/recruit-activity/': '招募链接',
  '#/public-link': '购机咨询页',
  '#/public-link/': '购机咨询页',
  '#/code': '导购企微二维码页',
  '#/code/': '导购企微二维码页'
};

// 参数模版
const meta = {
  app_key: "950252e5-b1b2-4948-84b8-27650d813f46",
  timestamp: "",
  begin_session: "",
  session_duration: "",
  end_session: "",
  device_id: '',
  action: "",
  remark: "",
  product_type: "h5",
  delay: false,
  ip: "",
  appinfo: {
    _version: "",
    _version_index: "",
    _package_name: "",
    _package_type: "1",
    _activity_name: "",
    _activity_mode: "",
    _preactivity_name: "",
    _platform_type: 'h5',
    _app_name: '线索录入',
    _current_page_title: TITLE_MAPS[location.hash.split('?')[0]] || '',
    _current_page_url: decodeURI(location.href)
  },
  deviceinfo: {
    _device_id: '',
    _idmd5: "",
    _ProductID: MACHINE_NO,
    _os: "",
    _os_version: "",
    _ip: "",
    _sys_version: "",
    _time_zone: "",
    _locale: "",
    _sdk_type: "",
    _sdk_version: "",
    _uid: "",
    _edu_stage: "",
    _grade: "",
    _roleid: "",
    _temp_roleid: "",
    _netSSID: "",
    _netMac: "",
    _address: "",
    _longitude: "",
    _latitude: "",
    unionId: "",
    openId: "",
    guideID: "",
  },
};
const events = [{
  key: "",
  count: "1",
  timestamp: "",
  delay: false,
  sum: "1",
  segmentation: {},
},];

function formatData(event, metaConfig = {}) {
  let timestamp = event.timestamp || new Date().getTime();
  timestamp = timestamp + "";
  const {
    appinfo,
    deviceinfo,
    ...rest
  } = meta;
  const {
    appinfo: appinfoConfig,
    deviceinfo: deviceinfoConfig,
    ...others
  } = metaConfig;
  console.log(TITLE_MAPS[location.hash.split('?')[0]] || '');
  const newMeta = {
    ...rest,
    ...others,
    appinfo: {
      ...appinfo,
      ...appinfoConfig,
      _current_page_title: TITLE_MAPS[location.hash.split('?')[0]] || '',
      _current_page_url: decodeURI(location.href)
    },
    deviceinfo: {
      ...deviceinfo,
      ...deviceinfoConfig
    }
  };
  newMeta.timestamp = timestamp;
  events[0].timestamp = timestamp;
  events[0].key = event.eventKey;
  delete event.eventKey;
  events[0].segmentation = Object.assign({}, event, {
    pt: "h5",
    pn: "h5",
    pageType: "h5",
  });
  let arr = [];
  for (const key of Object.keys(newMeta)) {
    if (typeof newMeta[key] == "object") {
      arr.push(key + "=" + encodeURIComponent(JSON.stringify(newMeta[key])));
    } else {
      arr.push(key + "=" + encodeURIComponent(newMeta[key]));
    }
  }
  arr.push("events" + "=" + encodeURIComponent(JSON.stringify(events)));
  return arr.join("&");
}

let initialized = false; // 初始化是否完成

export function register({
  unionId,
  openId,
  cookieId
}) {
  Object.assign(meta.deviceinfo, {
    unionId,
    openId,
    cookieId,
    _device_id: unionId || openId || cookieId
  });
  meta.device_id = unionId || openId || cookieId
  initialized = true;
}

export function report(event, metaConfig) {
  if (!initialized) {
    setTimeout(() => {
      report(event, metaConfig);
    }, 200);
  } else {
    axios.post("https://hd.youxuepai.com/hadRecord/record/upload", formatData(event, metaConfig));
  }
}
// 根据页面公用参数配置生成上报函数
export function trackerConfig(config = {}, metaConfig = {}) {
  return (prop) => report({
    ...config,
    ...prop
  }, metaConfig);
}

// 事件名
export const PAGE_EXPOSE = 'PAGE_EXPOSE'; // 页面曝光
export const BUTTON_CLICK = 'BUTTON_CLICK'; // 按钮点击
export const ELEMENT_EXPOSE = 'ELEMENT_EXPOSE'; //元素曝光
export const LIST_PAGE_EXPOSE = 'LIST_PAGE_EXPOSE'; //列表页条目曝光
export const DETAIL_PAGE_EXPOSE = 'DETAIL_PAGE_EXPOSE' //详情页曝光
export const VIDEO_START_PLAY = 'VIDEO_START_PLAY' //开始播放
export const VIDEO_DRAG = 'VIDEO_DRAG' //拖动
export const VIDEO_PROGRESSBAR_CLICK = 'VIDEO_PROGRESSBAR_CLICK' //模块按钮点击/进度条点击/快进/快退


// https://hd.youxuepai.com/hadRecord/record/upload?
// app_key=6fd9509e-d39b-4108-9010-c762cacd2d29
// timestamp=1664423629215
// begin_session=
// session_duration=
// end_session=
// device_id=7580943260781118728
// action=
// remark=
// product_type=faceConsulting
// delay=false
// ip=
// appinfo={"_version":"","_version_index":"","_package_name":"","_package_type":"1","_activity_name":"","_activity_mode":"","_preactivity_name":""}
// deviceinfo={"_device_id":"7580943260781118728","_idmd5":"","_ProductID":"7580943260781118728","_os":"","_os_version":"","_ip":"","_sys_version":"","_time_zone":"","_locale":"","_sdk_type":"","_sdk_version":"","_uid":"","_edu_stage":"","_grade":"","_roleid":"","_temp_roleid":"","_netSSID":"","_netMac":"","_address":"","_longitude":"","_latitude":"","unionId":"oxBZl00ZU0l5vE0q0vNNkrATtNrE","guideID":""}
// events=[{"key":"PAGE_EXPOSE","count":"1","timestamp":"1664423629215","delay":false,"sum":"1","segmentation":{"pageName":"诊断报告页","pageId":"30001","fromPage":{"pageId":"","pageName":""},"pt":"wxmini","pn":"优学成长学苑","pageType":"h5"}}]